import { request } from "@/utils/request";

export const testSign = () => {
    return request.get('/test-sign', { name: 'Leo' })
}
export const testSignPost = () => {
    return request.post('/test-sign', { use: 'test sign' })
}
export const getQuestion = (data: any) => {
    return request.post('/v1/scan/get-question', data)  
}
export const getCorrect = (data: any) => {
    return request.post('/v1/scan/correct-h5', data)
}
export const getVideoInfo = (data: any) => {
    return request.post('/v1/scan/video', data)
}
// 学习报告详情
export const getReportInfo = (data: any) => {
    return request.get('/v1/learn/report-info', data)
}
// 微信分享配置参数
export const getWxConfig = (data) => {
    return request.post('/wechat/sign', data)
}
// 获取智能推荐的题目信息
export const getReCommendQuestion = (data: any) => {
    return request.get('/v1/recommend/recommend', data)
}
// 根据id收藏或取消收藏题目
export const collectionQuestion = (data: any) => {
    return request.post('/v1/recommend/collection', data)
}
// 获取收藏的题目id列表
export const getCollectionIds = () => {
    return request.get('/v1/recommend/collection-list')
}
// 根据id获取收藏题目详情
export const getCollectionDetailByIds = (data: any) => {
    return request.get('/v1/recommend/detail', data)
}
// 参与内测邀请
export const joinPublicity = () => {
    return request.post('/v1/publicity/join')
}
// 加入错题本
export const addWrongQuestion = (data: any) => {
    return request.post('/v1/question/add-wrong-question', data)
}
// 批量加入错题本
export const addWrongQuestionBatch = (data: any) => {
    return request.post('/bookapi/v1/question/batch-add-wrong-question', data)
}
// 移出错题本
export const cancelWrongQuestion = (data: any) => {
    return request.post('/v1/question/cancel-wrong-question', data)
}
// 批量移出错题本
export const cancelWrongQuestionBatch = (data: any) => {
return request.post('/bookapi/v1/question/batch-cancel-wrong-question', data)
}
// 获取错题本题目状态
export const checkWrongQuestionStatus = (data: any) => {
    return request.get('/v1/question/wrong-question-join-status', data)
}
// 错题本列表
export const getWrongQuestionList = (data: any) => {
    return request.get('/v1/question/wrong-question-list', data)
}
// 个人信息收集清单
export const getConfigCollection = () => {
    return request.get('/v1/config/collection')
}
// 账号注销原因列表
export const getDestroyReason = () => {
    return request.post('/v1/auth/get-destroy-reason')
}
// 获取视频详情
export const getVideoDetail = (data: any) => {
    return request.post('/v1/scan/video-detail', data)
}
// 获取用户设置列表
export const getSettingsList = () => {
    return request.post('/v1/user/settings/list')
}
// 获取支持图书列表
export const getSuportBookList = () => {
    return request.get('/v1/scan/book')
}

/**
 * 识字卡
 */

//  字卡红点清除
export const redotClear = (data: {redot_type: number}) => {
    return request.post('/klpbookapi/redot/v1/clear', data)
}

//  字卡列表
export const cardList = (data) => {
    return request.get('/bookapi/v1/bookrack/cards', data)
}

//  用户作品详情
export const userWorks = (data) => {
    return request.get('/klpbookapi/study/v1/user-works/detail', data)
}
